import api from './axios';

// Settings API
export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.patch('/settings', data),
  uploadLogo: (formData) => api.post('/settings/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteLogo: () => api.delete('/settings/logo'),
  uploadFavicon: (formData) => api.post('/settings/favicon', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteFavicon: () => api.delete('/settings/favicon'),
  uploadLabAssistantSignature: (formData) => api.post('/settings/lab-assistant-signature', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteLabAssistantSignature: () => api.delete('/settings/lab-assistant-signature'),
  uploadLabInchargeSignature: (formData) => api.post('/settings/lab-incharge-signature', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteLabInchargeSignature: () => api.delete('/settings/lab-incharge-signature'),
  uploadPdfWatermark: (formData) => api.post('/settings/pdf-watermark', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deletePdfWatermark: () => api.delete('/settings/pdf-watermark')
};

export default settingsAPI;
